import React, { Component } from 'react';
import { View } from 'react-native';

import Text from '../../react-component/textComponent';

import Colors from '../../config/Colors';

import getHorasSincronizacao from './api';

const DIAS_MIN_LIMITE_SINCRONIZACAO = 24;
const DIAS_LIMITE_SINCRONIZACAO = 48;

class AvisoSincronizacao extends Component {
    state = {
        horasSincronizacao: 0
    };

    constructor(props) {
        super(props);

        this._isMounted = false;
    }

    componentDidMount = async () => {
        this._isMounted = true;

        const request = this._isMounted && (await getHorasSincronizacao()),
            response = request.data || {},
            { horas = null } = response;

        if (!horas) {
            return false;
        } else {
            this.setState({ ...this.state, horasSincronizacao: horas });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const { horasSincronizacao } = this.state,
            warningColor =
                horasSincronizacao < DIAS_LIMITE_SINCRONIZACAO
                    ? Colors.warning
                    : Colors.danger;

        if (horasSincronizacao < DIAS_MIN_LIMITE_SINCRONIZACAO) return <View />;

        if (this._isMounted && horasSincronizacao) {
            return (
                <View
                    style={{
                        backgroundColor: warningColor,
                        height: 40,
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Text
                        style={{
                            color: Colors.white,
                            fontSize: 16,
                            textAlign: 'center'
                        }}
                    >
                        Produtos estão há {horasSincronizacao} horas sem
                        sincronização
                    </Text>
                </View>
            );
        }
    }
}

export default AvisoSincronizacao;
